'use client';
import { usePathname } from '@/i18n/navigation';
import { event_global_variables } from './gtm';
import { flushPromotions } from './gtm/promotion-impressions';
import useShippingInfoStore from '@/store/shipping-info.store';
import { useSession } from 'next-auth/react';
import { useLocale } from 'next-intl';
import { useEffect } from 'react';

function ViewPage() {
  const pathname = usePathname();
  const locale = useLocale();
  const { data: session, status } = useSession();
  const shippingMethod = useShippingInfoStore((state) => state.shippingMethod);
  const shippingAddress = useShippingInfoStore(
    (state) => state.shippingAddress
  );

  useEffect(() => {
    // to avoid sending event when session is loading
    if (status === 'loading') return;
    event_global_variables({
      pathname,
      locale,
      session,
      shippingMethod,
      shippingAddress,
    });
  }, [pathname, locale, status, session, shippingMethod, shippingAddress]);

  // Spec: pending promotion impressions are pushed when the shopper navigates
  // away. This component is mounted for the life of the app, so its cleanup is
  // the one reliable per-route hook.
  useEffect(() => () => flushPromotions(), [pathname]);

  return <></>;
}

export default ViewPage;
